import React from 'react'
import PropTypes from 'prop-types'
import { Link, graphql, StaticQuery } from 'gatsby' 
import Img from "gatsby-image";

class BlogRoll extends React.Component {
  render() {
    const { data } = this.props
    const { edges: posts } = data.allMarkdownRemark

    return (
      <div class="mt-12 max-w-lg mx-auto grid gap-5 lg:grid-cols-3 lg:max-w-none">
        {posts &&
          posts.map(({ node: post }) => (

            <div class="flex flex-col rounded-lg bg-white shadow-lg overflow-hidden" key={post.id}>
               <article
                className={`blog-list-item tile is-child box notification ${
                  post.frontmatter.featuredpost ? 'is-featured' : ''
                }`}
              >
        <div class="flex-shrink-0">
          <Img
          fluid={post.frontmatter.featuredimage.childImageSharp.fluid}
          alt={'img title'}
          className="h-48 w-full object-cover"
        />

          {/* <img class="h-48 w-full object-cover" src="https://images.unsplash.com/photo-1496128858413-b36217c2ce36?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80" alt=""> */}
        </div>
        <div class="flex-1 p-6 flex flex-col justify-between">
          <div class="flex-1">
            <p class="text-sm font-medium text-brand-600">
              <a href="#" class="hover:underline">
                Article
              </a>
            </p>
            <Link className="block mt-2"  to={post.fields.slug}>

              <p class="text-xl font-semibold text-gray-900">
              {post.frontmatter.title}
              </p>
              <p class="mt-3 text-base text-gray-500">
               {post.excerpt.slice(0,130)}...</p>
              </Link>
          </div>
          <div class="mt-6 flex items-center">
            <div class="flex-shrink-0">
              <a href="#">
                <span class="sr-only">Roel Aufderehar</span>
                {/* <img class="h-10 w-10 rounded-full" src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80" alt=""> */}
              </a>
            </div>
            <div  >
              <p class="text-sm font-medium text-gray-900">
                <a href="#" class="hover:underline">
                 {post.frontmatter.author.frontmatter.name}
                </a>
              </p>
              <div class="flex space-x-1 text-sm text-gray-500">
                <time datetime={post.frontmatter.date}>
                {post.frontmatter.date}
                </time>
                <span aria-hidden="true">
                  &middot;
                </span>
               
                <Link className="button" to={post.fields.slug}>
                    Keep Reading →
                  </Link>
              </div>
            </div>
          </div>
        </div>
        </article>
      </div>

 
          ))}
      </div>
    )
  }
}

BlogRoll.propTypes = {
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      edges: PropTypes.array,
    }),
  }),
}

export default () => (
  <StaticQuery
    query={graphql`
      query BlogRollQuery {
        allMarkdownRemark(
          sort: { order: DESC, fields: [frontmatter___date] }
          filter: { frontmatter: { templateKey: { eq: "blog-post" } } }
        ) {
          edges {
            node {
              excerpt(pruneLength: 400)
              id
              fields {
                slug
              }
              frontmatter {
                title
                templateKey
                date(formatString: "MMMM DD, YYYY")
                featuredpost
                featuredimage {
                  childImageSharp {
                    fluid(maxWidth: 400, quality: 100) {
                      ...GatsbyImageSharpFluid_withWebp
                    }
                  }
                }
                author {
                  frontmatter {
                    name
                  }
                }
              }
            }
          }
        }
      }
    `}
    render={(data, count) => <BlogRoll data={data} count={count} />}
  />
)
